import ResizeObserver from "resize-observer-polyfill";

export const ResizeObserverPolyfill = ResizeObserver;

type MediaWatchCallback = (this: MediaQueryList, ev: MediaQueryListEvent) => unknown;
export const mediaWatchEventListenerPonyfill = {
  addEventListener(mediaWatch: MediaQueryList, callback: MediaWatchCallback) {
    if (typeof mediaWatch.addEventListener === "undefined") {
      return mediaWatch.addListener(callback);
    }

    return mediaWatch.addEventListener("change", callback);
  },
  removeEventListener(mediaWatch: MediaQueryList, callback: MediaWatchCallback) {
    if (typeof mediaWatch.removeEventListener === "undefined") {
      return mediaWatch.removeListener(callback);
    }

    return mediaWatch.removeEventListener("change", callback);
  }
};
